import { useSessionTimeout } from "../../hooks/useSessionTimeout";

export const SessionManager: React.FC = () => {
  useSessionTimeout();
  return null;
};
